import React, { useContext } from "react";
import PropTypes from "prop-types";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Box,
} from "@mui/material";
import MotionPlus from "../../Icons/MotionPlus";
import MotionMinus from "../../Icons/MotionMinus";
import EMPChip from "../EMPChip/EMPChip";
import { UserContext } from "../../context/userContext";
import { IS_FORD_BRAND } from "../../../utils/EmpUtil";

const FORD_FONT_FAMILY = '"FordF1Regular", Arial, sans-serif';
const LINCOLN_FONT_FAMILY =
  '"ProximaNovaRegular", "Lincoln Proxima Nova", Arial, sans-serif';

const EMPAccordion = ({
  children,
  heading,
  subHeading,
  onChange,
  expanded,
  prefixIconType,
  toggleIconColor,
  headingClassName,
}) => {
  const { user } = useContext(UserContext);
  const isFordBrand = IS_FORD_BRAND(user?.brand);
  const brandFontFamily = isFordBrand ? FORD_FONT_FAMILY : LINCOLN_FONT_FAMILY;
  const statusChip =
    prefixIconType === "caution" ? (
      <EMPChip
        label="Incomplete"
        labelColor="warning"
        size="medium"
        labelFontFamily={brandFontFamily}
      />
    ) : prefixIconType === "check" ? (
      <EMPChip
        label="Complete"
        labelColor="success"
        size="medium"
        labelFontFamily={brandFontFamily}
      />
    ) : null;

  return (
    <Accordion
      square
      elevation={0}
      disableGutters
      onChange={onChange}
      expanded={expanded}
    >
      <AccordionSummary
        expandIcon={
          expanded ? (
            <MotionMinus color={toggleIconColor} />
          ) : (
            <MotionPlus color={toggleIconColor} />
          )
        }
        sx={{ px: 4, py: 0 }}
      >
        <Box sx={{ mt: "40px", mb: "40px" }}>
          <Typography
            variant="h4"
            color="inherit"
            className={headingClassName}
            sx={{
              mb: "4px",
              fontFamily: brandFontFamily,
              fontSize: "20px",
              lineHeight: "28px",
              fontWeight: 600,
            }}
          >
            {heading}
          </Typography>
          {statusChip && <Box>{statusChip}</Box>}
          <Typography
            variant="body1"
            sx={{
              fontFamily: brandFontFamily,
              fontSize: "16px",
              lineHeight: "24px",
            }}
          >
            {subHeading}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails data-testid="accordion-details" sx={{ pb: "40px" }}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

EMPAccordion.propTypes = {
  children: PropTypes.node,
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  onChange: PropTypes.func,
  expanded: PropTypes.bool,
  prefixIconType: PropTypes.oneOf(["caution", "check"]),
  toggleIconColor: PropTypes.string,
  headingClassName: PropTypes.string,
};

export default EMPAccordion;
